import type { OptionKey } from '@shared/types/frontend/ubff/hotel-detail-price';
import type { ButtonType } from '@skyscanner-internal/hotel-unified-bff-web-http-client/dist/skyscanner/hotelunifiedbff/hotelprice/v1/hotel_price.pb';

export const UBFF_FILTER_KEYS_MAP: Record<OptionKey, string> = {
  OPTION_KEY_ROOM_TYPE: 'OPTION_KEY_ROOM_TYPE',
  OPTION_KEY_ROOM_TYPE_GROUP: 'OPTION_KEY_ROOM_TYPE_GROUP',
  OPTION_KEY_PROVIDER: 'OPTION_KEY_PROVIDER',
  OPTION_KEY_CONFIRMATION_TYPE: 'OPTION_KEY_CONFIRMATION_TYPE',
  OPTION_KEY_MEAL_PLAN: 'OPTION_KEY_MEAL_PLAN',
  OPTION_KEY_CANCELLATION_POLICY: 'OPTION_KEY_CANCELLATION_POLICY',
  OPTION_KEY_BED_TYPE: 'OPTION_KEY_BED_TYPE',
  OPTION_KEY_LODGING_TYPE: 'OPTION_KEY_LODGING_TYPE',
  OPTION_KEY_FAMILY_FRIENDLY: 'OPTION_KEY_FAMILY_FRIENDLY',
  OPTION_KEY_UNSPECIFIED: 'OPTION_KEY_UNSPECIFIED',
};

export const OFFER_OPTION_KEYS = [
  UBFF_FILTER_KEYS_MAP.OPTION_KEY_CONFIRMATION_TYPE,
  UBFF_FILTER_KEYS_MAP.OPTION_KEY_MEAL_PLAN,
  UBFF_FILTER_KEYS_MAP.OPTION_KEY_CANCELLATION_POLICY,
] as const;

export const UBFF_BUTTON_TYPES_MAP: Record<ButtonType, string> = {
  BUTTON_TYPE_SINGLE_SELECT: 'BUTTON_TYPE_SINGLE_SELECT',
  BUTTON_TYPE_MULTI_SELECT: 'BUTTON_TYPE_MULTI_SELECT',
  BUTTON_TYPE_UNSPECIFIED: 'BUTTON_TYPE_UNSPECIFIED',
};

export const ROOM_DIMENSION_FILTER_KEYS = [
  UBFF_FILTER_KEYS_MAP.OPTION_KEY_BED_TYPE,
  UBFF_FILTER_KEYS_MAP.OPTION_KEY_LODGING_TYPE,
  UBFF_FILTER_KEYS_MAP.OPTION_KEY_FAMILY_FRIENDLY,
] as const;

export const BED_TYPE_KEYS = [
  UBFF_FILTER_KEYS_MAP.OPTION_KEY_ROOM_TYPE_GROUP,
  ...ROOM_DIMENSION_FILTER_KEYS,
] as const;

export const ROOM_TYPE_KEYS = [
  UBFF_FILTER_KEYS_MAP.OPTION_KEY_ROOM_TYPE,
  ...BED_TYPE_KEYS,
] as const;
